import { createGeminiImage, isGeminiAvailable } from './gemini-client.js';

const form = document.querySelector('[data-drawing-form]');
const styleInputs = document.querySelectorAll('input[name="drawing-style"]');
const promptInput = document.querySelector('#drawing-prompt');
const statusEl = document.querySelector('[data-status]');
const resultFrame = document.querySelector('[data-result-img]');
const downloadBtn = document.querySelector('[data-download]');
const suggestionButtons = document.querySelectorAll('[data-prompt-template]');

const STYLE_PRESETS = {
  line: {
    label: 'line study',
    promptCue: 'ultra-minimal line art, few strokes, clear silhouette, no shading, no color'
  },
  cartoon: {
    label: 'cartoon story',
    promptCue: 'slightly fuller cartoon outline, rounded forms, light hatching only, no color'
  }
};

let selectedStyle = 'line';
let lastPrompt = '';
let lastResultBase64 = '';
let serviceReady = true;
let busy = false;

function setStatus(message, isError = false) {
  if (!statusEl) return;
  statusEl.textContent = message;
  statusEl.classList.toggle('error', isError);
}

function setResult(base64) {
  if (!resultFrame) return;
  if (!base64) {
    resultFrame.style.backgroundImage = '';
    resultFrame.classList.add('placeholder');
    downloadBtn?.classList.add('is-hidden');
    return;
  }
  lastResultBase64 = base64;
  const dataUrl = `data:image/png;base64,${base64}`;
  resultFrame.style.backgroundImage = `url(${dataUrl})`;
  resultFrame.classList.remove('placeholder');
  if (downloadBtn) {
    downloadBtn.href = dataUrl;
    downloadBtn.classList.remove('is-hidden');
  }
}

function buildPrompt(userPrompt, styleKey) {
  const preset = STYLE_PRESETS[styleKey] || STYLE_PRESETS.line;
  return `
Create a single, trace-ready rabbit drawing in ${preset.label} style.
- Use ${preset.promptCue}.
- Keep it black-and-white line work with a light cream background; no color fills.
- Clean outlines, minimal shading (if any), and consistent camera angle.
- Keep eyes below ear line, tail small and round, body proportions tidy.
- Optional prop/pose from the artist: ${userPrompt}
Return only the final drawing, centered with generous white space.`;
}

async function initServiceAvailability() {
  serviceReady = await isGeminiAvailable();
  if (!serviceReady) {
    form?.classList.add('tool-disabled');
    setStatus('Image generation is offline right now. Tools are in preview mode.', true);
  }
}

async function handleGenerate(useLastPrompt = false) {
  if (busy) return;
  if (!serviceReady) {
    setStatus('Image generation is offline. Please try again later.', true);
    return;
  }
  const promptText = useLastPrompt ? lastPrompt : promptInput?.value.trim();
  if (!promptText) {
    setStatus('Please enter a prompt (pose, prop, vibe) before generating.', true);
    return;
  }

  busy = true;
  form?.classList.add('is-busy');
  setStatus('Drawing your trace-ready outline—this takes about 10-15 seconds…');

  try {
    lastPrompt = promptText;
    const prompt = buildPrompt(promptText, selectedStyle);
    const output = await createGeminiImage({ prompt });
    setResult(output);
    setStatus('Tutorial ready! Download it and start tracing.');
  } catch (error) {
    console.error(error);
    setStatus(error.message || 'Generation failed. Please try again.', true);
    if (lastResultBase64) {
      setResult(lastResultBase64);
    }
  } finally {
    busy = false;
    form?.classList.remove('is-busy');
  }
}

styleInputs.forEach((input) => {
  if (input.checked) selectedStyle = input.value;
  input.addEventListener('change', () => {
    selectedStyle = input.value;
  });
});

suggestionButtons.forEach((button) => {
  button.addEventListener('click', () => {
    const text = button.dataset.promptTemplate || '';
    if (!promptInput) return;
    promptInput.value = text;
    promptInput.focus();
  });
});

form?.addEventListener('submit', (event) => {
  event.preventDefault();
  handleGenerate(false);
});

initServiceAvailability();
